var applyDiscountCode = function() {
  $('#discount-code-error').hide();
  
  const knownValidCode = "invalid-expired";
  const BUSDFreeMemDisCode = "RAFTBUSD-expired";
  const SCCOEFreeMemDisCode = "SCCOEAWARD-expired";  /* Coupon SCCOEAward */
  const TenPercentCouponCode = "synopsys10";         /* July 24 - Oct 31 2026 */
  const DeAnzaCouponCode = "deanza10-expired";
  const classBundleDisCode = "STEAM10-expired";
  const classBundle2DisCode = "RAFT10-expired";
  const conferenceKitDisCode = "HSC50";
  const BAP15DisCode = "BAP15"; // 15% off all Spark products
  
  var code = $('#discount-code-input').val();
  /*
  if (code) {
    code = code.toLowerCase();
  }
  */
  /* check for expired Discount code */
  if (code.indexOf("expired") !== -1) {
    $('#discount-code-error').css( "display", "block" );
  } else {
    if (code == knownValidCode) {
        applyDiscount(code);
    } else if (code.toUpperCase() == classBundleDisCode) {
        applyClassBundleDiscount(code);
    } else if (code.toUpperCase() == classBundle2DisCode) {
        applyClassBundleDiscount(code);   
    } else if (code == conferenceKitDisCode) {
        applyConferenceKitDiscount(code);
    } else if (code.toUpperCase() == BAP15DisCode) {
        applyBAP15Discount(code); 
    } else if ((code.toUpperCase() == BUSDFreeMemDisCode) || (code.toUpperCase() == SCCOEFreeMemDisCode)) {
        applyPrepaidFreeMemDiscount(code);
    } else if ((code.toLowerCase() == TenPercentCouponCode) || (code.toLowerCase() == DeAnzaCouponCode)) {
        applyTenPercentCoupon(code);
    } else {
      $('#discount-code-error').css( "display", "block" );
    }
  }
}

var applyDiscount = function(code) {
  $('.order-discount-cart-wrapper-custom').css( "display", "block" );
  $('#applied-discount-code').html(code);
  
  window.hasDiscountApplied = true;
  window.appliedDiscountPrecent = 15;
  window.appliedDiscountCode = code;
  
  var cartTotalMaster = $('#price-for-discount').html();
  var cartTotal = cartTotalMaster;
  cartTotal = cartTotal / 100;
  
  var cartItems = window.shoppingCartItems;
  cartItems.forEach((product) => {
    if (product.tags.includes("Membership")) {
      var productPrice = product.variantInCart.final_price / 100;

      cartTotal -= productPrice;
    }
  });
  
  var discountAmount = cartTotal * .15;
  cartTotal = (cartTotalMaster / 100) - discountAmount;
  
  window.appliedDiscountAmount = discountAmount;
  
  $('.cart__subtotal-price').hide();
  $('#applied-discount-subtotal-container').css( "display", "inline" );
  $('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
  $('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
  
  getAppliedDiscount();
}


var applyClassBundleDiscount = function(code) {
	$('.order-discount-cart-wrapper-custom').css( "display", "block" );
	$('#applied-discount-code').html(code);
	
	window.hasDiscountApplied = true;
	window.appliedDiscountPrecent = 10;
	window.appliedDiscountCode = code;
	
	var cartTotalMaster = $('#price-for-discount').html();
	var cartTotal = cartTotalMaster;
	cartTotal = cartTotal / 100;
	
	var cartItems = window.shoppingCartItems;
	var priceToDiscount = 0;
	cartItems.forEach((product) => {
		// Use String#indexOf() since String#includes() not supported in IE
	    if ((product.title.indexOf('Classroom Bundle') !== -1)) {
		   var productPrice = product.variantInCart.final_price /100 ;
		   var quantity = product.variantInCart.quantity;
  
		priceToDiscount += productPrice * quantity;
	  }
	});
	var discountAmount = priceToDiscount * .1;
	cartTotal = (cartTotalMaster / 100) - discountAmount;
	
	window.appliedDiscountAmount = discountAmount;
	
	$('.cart__subtotal-price').hide();
	$('#applied-discount-subtotal-container').css( "display", "inline" );
	$('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
	$('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
	
	getAppliedDiscount();
  }


var applyConferenceKitDiscount = function(code) {
	$('.order-discount-cart-wrapper-custom').css( "display", "block" );
	$('#applied-discount-code').html(code);
	
	window.hasDiscountApplied = true;
	window.appliedDiscountPercent = 50;
	window.appliedDiscountCode = code;
	
	var cartTotalMaster = $('#price-for-discount').html();
	var cartTotal = cartTotalMaster;
	cartTotal = cartTotal / 100;
	
	var cartItems = window.shoppingCartItems;
	var priceToDiscount = 0;
  var asMember = false;

  if (window.isMember && product.memberPrice) {
      asMember = true;
  }
	cartItems.forEach((product) => {
		// Use String#indexOf() since String#includes() not supported in IE
	    if ((product.title.indexOf("Car on a Roll") != -1) || (product.title.indexOf("Colors of Light") != -1)) {
		   var productPrice;
       if (asMember) {
           productPrice = product.memberPrice;
       } else {
           productPrice = product.variantInCart.final_price /100 ;
       }
		   var quantity = product.variantInCart.quantity;
  
		   priceToDiscount += productPrice * quantity;
	  }
	});
  var discountAmount; 
  if (asMember) {
    discountAmount = priceToDiscount * .5;
  }
  else {
	  discountAmount = priceToDiscount;
  }
	cartTotal = (cartTotalMaster / 100) - discountAmount;
	
	window.appliedDiscountAmount = discountAmount;
	
	$('.cart__subtotal-price').hide();
	$('#applied-discount-subtotal-container').css( "display", "inline" );
	$('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
	$('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
	
	getAppliedDiscount();
  }

// Prepaid Free membership sponsared by First 5 for all memberships
var applyPrepaidFreeMemDiscount = function(code) {
    $('.order-discount-cart-wrapper-custom').css( "display", "block" );
    $('#applied-discount-code').html(code);
    
    window.hasDiscountApplied = true;
    window.appliedDiscountCode = code;
    
    var cartTotalMaster = $('#price-for-discount').html();
    var cartTotal = cartTotalMaster;
    cartTotal = cartTotal / 100;
    
    var cartItems = window.shoppingCartItems;
    var priceToDiscount = 0;
    cartItems.forEach((product) => {
      if (product.title.indexOf("Membership") >= 0) {
        var productPrice = product.variantInCart.final_price /100 ;
        var quantity = product.variantInCart.quantity;
  
        priceToDiscount += productPrice * quantity;
      }
    });
    var discountAmount = priceToDiscount;
    cartTotal = (cartTotalMaster / 100) - discountAmount;
    
    window.appliedDiscountAmount = discountAmount;
    
    $('.cart__subtotal-price').hide();
    $('#applied-discount-subtotal-container').css( "display", "inline" );
    $('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
    $('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
    
    getAppliedDiscount();
}

var applyTenPercentCoupon = function(code) {
    $('.order-discount-cart-wrapper-custom').css( "display", "block" );
    $('#applied-discount-code').html(code);
    
    window.hasDiscountApplied = true;
    window.appliedDiscountCode = code;
    
    var cartTotalMaster = $('#price-for-discount').html();
    var cartTotal = cartTotalMaster;
    cartTotal = cartTotal / 100;
    
    var cartItems = window.shoppingCartItems;
    
    var discountAmount = 0;
    if (cartTotal > 10) {
      
      discountAmount = cartTotal * .1;
      cartTotal = cartTotal - discountAmount;
    }
    
    window.appliedDiscountAmount = discountAmount;
    
    $('.cart__subtotal-price').hide();
    $('#applied-discount-subtotal-container').css( "display", "inline" );
    $('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
    $('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
    
    getAppliedDiscount();
}

var cyberMondayDiscount = function() {
  $('#discount-code-error').hide();
  var code = $('#discount-code-input').val();
  $('.order-discount-cart-wrapper-custom').css( "display", "block" );
  $('#applied-discount-code').html(code);
  
  window.hasDiscountApplied = true;
  window.appliedDiscountPrecent = 20;
  window.appliedDiscountCode = code;
  
  var cartTotalMaster = $('#price-for-discount').html();
  var cartTotal = cartTotalMaster;
  cartTotal = cartTotal / 100;
  
  var cartItems = window.shoppingCartItems;
  var priceToDiscount = 0;
  
  cartItems.forEach((product) => {
  if ((product.title.indexOf('Subscription') == -1)
      && (product.title.indexOf('Single Box') == -1)
      && (product.title.indexOf('Classroom Pack') == -1)
      && (product.title.indexOf('Jasmine and José') == -1)
      && (product.title.indexOf('Membership') == -1)
      && (product.title.indexOf('3D Printing') == -1 ))
   {
      var productPrice = product.variantInCart.final_price /100 ;
      var quantity = product.variantInCart.quantity;
      priceToDiscount += productPrice * quantity;
   }
  });
  
  var discountAmount = priceToDiscount * .2;
  cartTotal = (cartTotalMaster / 100) - discountAmount;
  
  window.appliedDiscountAmount = discountAmount;
  
  $('.cart__subtotal-price').hide();
  $('#applied-discount-subtotal-container').css( "display", "inline" );
  $('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
  $('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
  
  getAppliedDiscount();
}

var backToSchoolDiscount = function() {
  $('#discount-code-error').hide();
  
  var code = $('#discount-code-input').val();
  $('.order-discount-cart-wrapper-custom').css( "display", "block" );
  $('#applied-discount-code').html(code);
  
  window.hasDiscountApplied = true;
  window.appliedDiscountPrecent = 15;
  
  var cartTotalMaster = $('#price-for-discount').html();
  var cartTotal = cartTotalMaster;
  cartTotal = cartTotal / 100;
  
  var cartItems = window.shoppingCartItems;
  var PriceToDiscount = 0;  // 15% off All Items except membership and subscription

  cartItems.forEach((product) => {
    if ((product.title.indexOf("Membership") == -1) 
      && (product.title.indexOf("Subscription") == -1)) {
         var productPrice = product.variantInCart.final_price /100 ;
         var quantity = product.variantInCart.quantity;
         PriceToDiscount += productPrice * quantity;
      }
  });

  var discountAmount = PriceToDiscount * .15;
  cartTotal = (cartTotalMaster / 100) - discountAmount;
  
  window.appliedDiscountAmount = discountAmount;
  
  $('.cart__subtotal-price').hide();
  $('#applied-discount-subtotal-container').css( "display", "inline" );
  $('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
  $('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
  
  getAppliedDiscount();
}

// 15% off all Spark STEAM Kits and All Project Kits products
var applyBAP15Discount = function(code) {
	$('.order-discount-cart-wrapper-custom').css( "display", "block" );
	$('#applied-discount-code').html(code);
	
	window.hasDiscountApplied = true;
	window.appliedDiscountCode = code;
	
	var cartTotalMaster = $('#price-for-discount').html();
	var cartTotal = cartTotalMaster;
	cartTotal = cartTotal / 100;
	
	var cartItems = window.shoppingCartItems;
	var priceToDiscount = 0;
  var priceToDiscountJJ = 0;
  var asMember = false;

  if (window.isMember && product.memberPrice) {
      asMember = true;
  }
	cartItems.forEach((product) => {
		// Use String#indexOf() since String#includes() not supported in IE
    
	    if ((product.title.indexOf("Spark STEAM Kit") != -1) || (product.tags.indexOf("All Kits") != -1)) {
		   var productPrice = 0;
       var productPrice15 = 0;
       var JJ = false;
       if (asMember) {
           productPrice = product.memberPrice;
       } else {
          if ((product.title.indexOf('Jasmine and Jos') != -1) || (product.title.indexOf("Spark STEAM Kit") != -1)) {
              productPrice15 = product.webPrice;
              JJ = true;
          } else if (product.title.indexOf('Archimedes Screw Model') != -1) {
              productPrice15 = product.variantInCart.final_price /100 ;
              JJ = true;
          } else {
              productPrice = product.variantInCart.final_price /100 ;
          }
       }
		   var quantity = product.variantInCart.quantity;
       if (JJ) {
           priceToDiscountJJ += productPrice15 * quantity;
           JJ = false;
       } else {
		       priceToDiscount += productPrice * quantity;
       }
	  }
	});
  var discountAmount; 
  if (asMember) {
    discountAmount = priceToDiscount * .15;
  }
  else {
	  discountAmount = priceToDiscount * .3 + priceToDiscountJJ * .15;
  }
	cartTotal = (cartTotalMaster / 100) - discountAmount;
	
	window.appliedDiscountAmount = discountAmount;
	
	$('.cart__subtotal-price').hide();
	$('#applied-discount-subtotal-container').css( "display", "inline" );
	$('#applied-discount-amount').html("(-$" + discountAmount.toFixed(2) + ")");
	$('#applied-discount-subtotal').html("$" + cartTotal.toFixed(2) + " USD");
	
	getAppliedDiscount();
  }
